import deepmerge from 'deepmerge'

import { AppConfig } from '../app-config'
import developmentConfig from './development'

const productionConfig = deepmerge<AppConfig>(developmentConfig, {
  baseApiPath: 'https://api.databiologics.com/',
  authHost: 'https://auth.databiologics.com/',
  helixLoginUrl: 'https://helix.databiologics.com/login',
  apmUrl: 'https://apm.databiologics.com/',
  tableauProductionBaseUrl: 'https://tableau.databiologics.com/',
  tableauProductionEmbeddedApiUrl:
    'https://tableau.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  tableauStagingBaseUrl: 'https://tableau-staging.databiologics.com/',
  tableauStagingEmbeddedApiUrl:
    'https://tableau-staging.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  googleMapsApiKey: 'AIzaSyDI2QYc4_MUQBPdgJeefb1sAQkEeAvf35g',
  stripePublictKey:
    'pk_live_51Mt0Y9Avm1kprluZo1A3xREFK74XbCAO4JnmmjWJqp5YJ4M4ZI7oiwaFhESBFRkZFgI2gjENdfwjaxeaPpuVXTs000KSbDrcJ0',
  sentryDSN:
    'https://bb0b293ad9a03c331851afda34909b43@o4510903226531840.ingest.us.sentry.io/4510975824625664',
  patientUrl: 'https://patient.databiologics.com',
  cdnPath: 'https://cdn.databiologics.com',
})

export default productionConfig
